import React from 'react';
import classnames from 'classnames';
import FormattedMessage from '@/intl/formatted-message';
import dishMenuMessages from '../../intl/messages/dish-menu';
import config from '../../config';
import commonHelper from '../../helper/common-helper';
import ccbAppHelper from '../../helper/Ccb-app-helper';
import './floating-navigation.scss';
import iParkHelper from '../../helper/iPark/iParkHelper';

const isIParkEvn = iParkHelper.isIParkEvn();
class FloatingNavigation extends React.Component {
  static propTypes = {
    shopInfo: React.PropTypes.object,
    orderType: React.PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      expand: false,
      // 避免页面第一次加载的时候就执行动画
      canAnimate: false,
    };

    this.toggleExpand = this.toggleExpand.bind(this);
  }

  getNavPageUrls() {
    const { shopInfo } = this.props;
    let isYaZuo = shopInfo ? shopInfo.isYaZuo : '';
    if (commonHelper.getUrlParam('isYaZuo')) {
      isYaZuo = commonHelper.getUrlParam('isYaZuo');
    }
    const shopId = commonHelper.getUrlParam('shopId');
    const tableId = commonHelper.getUrlParam('tableId') || sessionStorage.getItem('tableId');
    const type = commonHelper.getUrlParam('type');

    let mineIndexUrl = ''; // 个人中心
    let vipCenterUrl = ''; // 会员卡
    let orderListUrl = ''; // 订单中心
    let dishMenuListUrl = ''; // 点餐页

    if (type !== 'WM') {
      mineIndexUrl = `${config.mineIndexURL}?shopId=${shopId}&showNav=true&type=${type}${tableId ? `&tableId=${tableId}` : ''}`;
      vipCenterUrl = `${config.memberIndexURL}?shopId=${shopId}&showNav=true&type=${type}${tableId ? `&tableId=${tableId}` : ''}`;
      orderListUrl = `${config.orderallListURL}?shopId=${shopId}&showNav=true&type=${type}${tableId ? `&tableId=${tableId}` : ''}${
        isYaZuo ? `&isYaZuo=${isYaZuo}` : ''
      }`;
      dishMenuListUrl = `${config.dishMenu4DinnerURL}?shopId=${shopId}&type=${type}&showNav=true${tableId ? `&tableId=${tableId}` : ''}${
        isYaZuo ? `&isYaZuo=${isYaZuo}` : ''
      }`;
    }

    if (type === 'WM') {
      mineIndexUrl = `${config.mineIndexURL}?shopId=${shopId}&showNav=true&type=${type}${tableId ? `&tableId=${tableId}` : ''}`;
      vipCenterUrl = `${config.memberIndexURL}?shopId=${shopId}&showNav=true&type=${type}${tableId ? `&tableId=${tableId}` : ''}`;
      orderListUrl = `${config.orderallListURL}?shopId=${shopId}&showNav=true&type=${type}${tableId ? `&tableId=${tableId}` : ''}${
        isYaZuo ? `&isYaZuo=${isYaZuo}` : ''
      }`;
      dishMenuListUrl = `${config.dishMenu4takeoutURL}?shopId=${shopId}&type=${type}&showNav=true${tableId ? `&tableId=${tableId}` : ''}${
        isYaZuo ? `&isYaZuo=${isYaZuo}` : ''
      }`;
    }

    return {
      dishMenuListUrl,
      vipCenterUrl,
      mineIndexUrl,
      orderListUrl,
    };
  }

  setAnimationStatus() {
    return {
      animateIn: this.state.canAnimate && this.state.expand,
      animateOut: this.state.canAnimate && !this.state.expand,
    };
  }

  buildClosingLayer() {
    if (!this.state.expand) {
      return false;
    }
    return <div className="nav-closing-layer" onTouchTap={this.toggleExpand} />;
  }

  buildExpandControl() {
    return (
      <div className="expand-control">
        <button onTouchTap={this.toggleExpand}>
          {this.state.expand ? (
            <FormattedMessage {...dishMenuMessages.navigatorExpandedTitle} />
          ) : (
            <FormattedMessage {...dishMenuMessages.navigatorCollapsedTitle} />
          )}
          <i className={`icon icon-double-arrow-${this.state.expand ? 'left' : 'right'}`} />
        </button>
      </div>
    );
  }

  buildNavItems(animateIn, animateOut) {
    const { dishMenuListUrl, vipCenterUrl, mineIndexUrl, orderListUrl } = this.getNavPageUrls();
    const { shopInfo } = this.props;

    // 建行环境不显示会员卡和个人中心
    const isCcbEnv = commonHelper.getUrlParam('type') !== 'WM' && ccbAppHelper.isCcbEvn();

    let isYaZuo = shopInfo ? shopInfo.isYaZuo : '';

    if (commonHelper.getUrlParam('isYaZuo')) {
      isYaZuo = commonHelper.getUrlParam('isYaZuo');
    }

    let dishLink = '';

    const dishListNavItem =
      commonHelper.getUrlParam('type') === 'WM' ? (
        <FormattedMessage {...dishMenuMessages.navigatorCommodityList} />
      ) : (
        <FormattedMessage {...dishMenuMessages.navigatorDishList} />
      );

    if (isYaZuo) {
      dishLink = (
        <div
          className={classnames('nav-items', {
            'fade-in': animateIn,
            'fade-out': animateOut,
          })}
        >
          <div className="item o-pl">
            <a href={dishMenuListUrl}>
              <i className="icon icon-menu" />
              {dishListNavItem}
            </a>
          </div>
          <div className="item o-pl">
            <a href={orderListUrl}>
              <i className="icon icon-order-list" />
              <FormattedMessage {...dishMenuMessages.navigatorOrderCenter} />
            </a>
          </div>
        </div>
      );
    } else if (isIParkEvn) {
      dishLink = (
        <div
          className={classnames('nav-items', {
            'fade-in': animateIn,
            'fade-out': animateOut,
          })}
        >
          <div className="item o-mr o-mb" style={{ marginLeft: 3, marginTop: 1 }}>
            <a href={dishMenuListUrl}>
              <i className="icon icon-menu" />
              {dishListNavItem}
            </a>
          </div>
          <div className="item o-mr" style={{ marginLeft: 3, marginTop: -1 }}>
            <a href={orderListUrl}>
              <i className="icon icon-order-list" />
              <FormattedMessage {...dishMenuMessages.navigatorOrderCenter} />
            </a>
          </div>
        </div>
      );
    } else {
      dishLink = (
        <div
          className={classnames('nav-items', {
            'fade-in': animateIn,
            'fade-out': animateOut,
          })}
        >
          <div className="item o-mr o-mb" style={{ marginLeft: 3, marginTop: 1 }}>
            <a href={dishMenuListUrl}>
              <i className="icon icon-menu" />
              {dishListNavItem}
            </a>
          </div>
          {!isCcbEnv && (
            <div className="item" style={{ marginBottom: 5, marginTop: 1 }}>
              <a href={vipCenterUrl}>
                <i className="icon icon-card" />
                <FormattedMessage {...dishMenuMessages.navigatorMemberCard} />
              </a>
            </div>
          )}
          <div className="item o-mr" style={{ marginLeft: 3, marginTop: -1 }}>
            <a href={orderListUrl}>
              <i className="icon icon-order-list" />
              <FormattedMessage {...dishMenuMessages.navigatorOrderCenter} />
            </a>
          </div>
          {!isCcbEnv && (
            <div className="item" style={{ marginTop: -1 }}>
              <a href={mineIndexUrl}>
                <i className="icon icon-personal" />
                <FormattedMessage {...dishMenuMessages.navigatorMeCenter} />
              </a>
            </div>
          )}
        </div>
      );
    }

    return dishLink;
  }

  toggleExpand = e => {
    if (e) {
      e.preventDefault();
    }

    this.setState(prevState => ({
      canAnimate: true,
      expand: !prevState.expand,
    }));
  };

  render() {
    const { animateIn, animateOut } = this.setAnimationStatus();
    const closingLayer = this.buildClosingLayer();
    const navItems = this.buildNavItems(animateIn, animateOut);
    const expandControl = this.buildExpandControl();
    const { shopInfo } = this.props;
    let isYaZuo = shopInfo ? shopInfo.isYaZuo : false;
    // 建行环境不显示会员卡和个人中心
    const isCcbEnv = commonHelper.getUrlParam('type') !== 'WM' && ccbAppHelper.isCcbEvn();

    if (commonHelper.getUrlParam('isYaZuo')) {
      isYaZuo = commonHelper.getUrlParam('isYaZuo');
    }

    return (
      <div>
        <div
          className={classnames('nav-panel', {
            'nav-panel-in': animateIn,
            'nav-panel-out': animateOut,
          })}
          onTouchTap={this.toggleExpand}
        />
        <div
          className={classnames('floating-nav-container', {
            'floating-nav-container--modify': isYaZuo,
            'slide-left': !isYaZuo && animateOut,
            'slide-right': !isYaZuo && animateIn,
            'slide-left--modify': isYaZuo && animateOut,
            'slide-right--modify': isYaZuo && animateIn,
            'not-show-card': isCcbEnv && isIParkEvn && animateIn,
          })}
        >
          {navItems}
          {expandControl}
        </div>
        {closingLayer}
      </div>
    );
  }
}

export default FloatingNavigation;



// WEBPACK FOOTER //
// ./src/component/common/floating-navigation.jsx